import { Form } from "antd";
import isValid from "date-fns/isValid";
import type { NamePath } from "rc-field-form/es/interface";
import type { FormInstance } from "rc-field-form";

const useDateWatch = (
  dependencies: NamePath,
  form?: FormInstance
): Date | undefined => {
  const dateValue: string | undefined = Form.useWatch(dependencies, form);
  const date = new Date(dateValue || "");

  return isValid(date) ? date : undefined;
};

export default useDateWatch;
